import React from 'react';
import CaretIcon from '../../images/dropdown_caret.png';
import './Select.css';

const Select = (props) => {
  const { className, data = [], placeholder } = props;

  const attributes = {
    defaultValue: (placeholder
      ? ''
      : undefined),
    ...props,
    className: props.extraClass !== '' ? `select_ready form-select form-input-shadow end-customer` : 'form-select form-input-shadow end-customer',
    data: undefined,
    placeholder: undefined,
  };

  return (
    <div className={`form-select-parent ${className || ''}`}>
      <select {...attributes}>
        {placeholder
          ? (
            <option value=""
                    disabled
                    hidden>
              {placeholder}
            </option>
          )
          : null}
        {data.map((it) => (
          <option key={it.value}
                  disabled={it.disabled || false}
                  value={it.value}>
            {it.text}
          </option>
        ))}
      </select>
      <div className="form-select-caret">
        <img className="form-select-caret-icon"
             src={CaretIcon}
             alt="" />
      </div>
    </div>
  );
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/forms/Select.js